import { Injectable } from '@angular/core';
import { GoogleLoginProvider, SocialAuthService } from '@abacritt/angularx-social-login';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private authService: SocialAuthService) { }

  refreshToken() {
   
   
      return this.authService.refreshAuthToken(GoogleLoginProvider.PROVIDER_ID).then(token => {

        var userLocalStorage=localStorage.getItem("user");

        if (userLocalStorage) {
          var user = JSON.parse(userLocalStorage);

          user.idToken = token;

          localStorage.setItem("user", JSON.stringify(user));
        }

        this.authService.refreshAccessToken(GoogleLoginProvider.PROVIDER_ID).then(token => {
          
          this.setAccessToken();
        });
        
      });
      
      //this.setAccessToken();
    
  }

  setAccessToken(): Promise<string> {
    return this.authService.getAccessToken(GoogleLoginProvider.PROVIDER_ID).then(accessTokenRequested => {
      localStorage.setItem("access_token", accessTokenRequested);

      return accessTokenRequested;
    });
  }

  signOut() {
    this.authService.signOut();
    localStorage.removeItem("ut");
    localStorage.removeItem("plan");
    location.pathname = "/";
  }
}
